import { useGate, useUnit } from 'effector-react'
import {
  $accessibleArticles,
  $budgetListTeam,
  $budgetListOwn,
  $budgetListOwnApprove,
  $budgetListOwnReject,
  $budgetPeriods,
  $currentRequest,
  $filteredBudgetListTeam,
  $filteredBudgetListOwn,
  $filteredBudgetListOwnApprove,
  $filteredBudgetListOwnReject,
  $modalRequestsDelete,
  $modalRequestsReject,
  $modalRequestsApprove,
  $modalRequestsToSubmit,
  $modalRequestView,
  getBudgetListTeamFx,
  getBudgetListOwnFx,
  getBudgetPeriodListFx,
  getRequestContextFx,
  $modalRequestsCopy,
  $budgetPeriodOptions,
  BudgetPeriodGate,
  CreateContextGate,
  $budgetPeriodList,
  $teamOptions,
  $defaultTeamId,
  EditRequestGate,
  $modalRequestComment,
  CommentsGate,
  $commentList,
  CurrencyGate,
  $modalRequestRejectSeo,
  $budgetListOwnAll,
  $budgetListTeamAll,
  $budgetListUrgent,
  $filteredBudgetListUrgent,
  $currencies,
} from 'src/pages/budget/budgetRequests/model'

export const useBudgetPeriodGate = () => useGate(BudgetPeriodGate)
export const useCreateContextGate = () => useGate(CreateContextGate)
export const useRequestByIdGate = (id?: string) =>
  useGate(EditRequestGate, { id })
export const useCommentsGate = (id: number) => useGate(CommentsGate, { id })
export const useCurrencyGate = () => useGate(CurrencyGate)

export const useCurrencies = () => useUnit($currencies)


export const useBudgetPeriod = () => {
  const { loadingBudgetPeriodList, budgetPeriod, budgetPeriodOptions } =
    useUnit({
      loadingBudgetPeriodList: getBudgetPeriodListFx.pending,
      budgetPeriod: $budgetPeriods,
      budgetPeriodOptions: $budgetPeriodOptions,
    })
  return { loadingBudgetPeriodList, budgetPeriod, budgetPeriodOptions }
}

export const useBudgetListTeam = () => {
  const { budgetListTeamAll, filteredBudgetListTeam, budgetListTeam, loading } =
    useUnit({
      budgetListTeamAll: $budgetListTeamAll,
      filteredBudgetListTeam: $filteredBudgetListTeam,
      budgetListTeam: $budgetListTeam,
      loading: getBudgetListTeamFx.pending,
    })
  return {
    budgetListTeamAll,
    budgetListTeam,
    filteredBudgetListTeam,
    loading,
  }
}

export const useBudgetListOwn = () => {
  const {
    budgetListOwnAll,
    budgetListOwn,
    filteredBudgetListOwn,
    budgetListOwnApprove,
    filteredBudgetListOwnApprove,
    budgetListOwnReject,
    filteredBudgetListOwnReject,
    loading,
  } = useUnit({
    budgetListOwnAll: $budgetListOwnAll,
    budgetListOwn: $budgetListOwn,
    filteredBudgetListOwn: $filteredBudgetListOwn,
    budgetListOwnApprove: $budgetListOwnApprove,
    filteredBudgetListOwnApprove: $filteredBudgetListOwnApprove,
    budgetListOwnReject: $budgetListOwnReject,
    filteredBudgetListOwnReject: $filteredBudgetListOwnReject,
    loading: getBudgetListOwnFx.pending,
  })

  return {
    budgetListOwnAll,
    budgetListOwn,
    filteredBudgetListOwn,
    budgetListOwnApprove,
    filteredBudgetListOwnApprove,
    budgetListOwnReject,
    filteredBudgetListOwnReject,
    loading,
  }
}

export const useBudgetListUrgent = () => {
  const { budgetListUrgent, filteredBudgetListUrgent } = useUnit({
    budgetListUrgent: $budgetListUrgent,
    filteredBudgetListUrgent: $filteredBudgetListUrgent,
  })
  const loadingOwn = useUnit(getBudgetListOwnFx.pending)
  const loadingTeam = useUnit(getBudgetListTeamFx.pending)

  return {
    budgetListUrgent,
    filteredBudgetListUrgent,
    loadingOwn,
    loadingTeam,
  }
}

export const useContextRequest = () => {
  const accessibleArticles = useUnit($accessibleArticles)
  const teamsOptions = useUnit($teamOptions)
  const defaultTeamId = useUnit($defaultTeamId)
  const budgetPeriodList = useUnit($budgetPeriodList)
  const loading = useUnit(getRequestContextFx.pending)

  return {
    budgetPeriodList,
    accessibleArticles,
    teamsOptions,
    defaultTeamId,
    loading,
  }
}

export const useCurrentRequest = () => useUnit($currentRequest)

export const useCommentList = () => useUnit($commentList)

export const useModalRequestsDelete = () => useUnit($modalRequestsDelete)
export const useModalRequestsToSubmit = () => useUnit($modalRequestsToSubmit)
export const useModalRequestsApprove = () => useUnit($modalRequestsApprove)
export const useModalRequestsReject = () => useUnit($modalRequestsReject)
export const useModalRequestView = () => useUnit($modalRequestView)
export const useModalRequestsCopy = () => useUnit($modalRequestsCopy)
export const useModalRequestComment = () => useUnit($modalRequestComment)
export const useModalRequestRejectSeo = () => useUnit($modalRequestRejectSeo)
